<template>
	<div>
		<!-- <top></top> -->
		<div class="policy">
			<div class="flex align-center justify-between padding-sm bg-white margin-tb">
				<!-- <p class="text-sm text-666">首页 - 政策解读 - 详情</p>
				<p class="flex align-center text-999 text-sm pointer" @click="back()">
					<i class="el-icon-back"></i>
					<span>返回</span>
				</p> -->
				<el-breadcrumb separator-class="el-icon-minus">
				  <el-breadcrumb-item :to="{ path: '/' }"><span class="text-sm text-666">首页</span></el-breadcrumb-item>
				  <el-breadcrumb-item :to="{ path: 'policy' }"><span class="text-sm text-666">政策解读</span></el-breadcrumb-item>
				  <el-breadcrumb-item><span class="text-sm text-666">详情</span></el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="margin-bottom flex">
				<div class="detail bg-white padding-lr padding-bottom">
					<p class="detail-title text-bold text-left padding-tb-sm  solid-bottom">{{title}}</p>
					<p class="flex align-center justify-between padding-tb-sm">
						<span>{{create_time}}</span>
						<span>作者：宗边</span>
					</p>
					<div class="text-left" v-html="content"></div>
				</div>
				<div class="margin-left news">
					<div class="flex align-center justify-between margin-bottom-sm">
						<p class="title padding-left-sm">最新政策</p>
					</div>
					<div class="bg-white hotlist" style="border-radius: 10px;">
						<p class="text-left  padding-tb-sm text-666 text-xs padding-lr-xs solid-bottom" v-for="(item,index) in list" :key="index" @click="toDetail(item.id)">{{item.title}}.. </p>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import Top from '@/components/public/top.vue';
	import Bus from '@/store/eventBus.js'
	export default {
		components: {
			Top,
		},
		name: '',
		data() {
			return {
				content:'',
				create_time:'',
				title:'',
				list:[]

			}
		},
		created() {
			//通知听不状态栏 选中的页面
			Bus.$emit('chosename','home')
			this.id = this.$route.query.id
			this.getdetail()
			this.gethotList()
		},
		methods: {
			back(){
				this.$router.back()
			},
			getdetail(){
				this.ajax('get', '/api/policy/getInfo', {
					id:this.id,
				}, res => {
					if(res.status == 200){
						console.log(res);
						this.content = res.data.content
						this.create_time = res.data.create_time
						this.title = res.data.title
					}
				})
			},
			gethotList(){
				this.ajax('get', '/api/policy/getListNews', {

				}, res => {
					if(res.status == 200){
						this.list = res.data
					}
				})
			},
      // 右侧最新跳转详情
      toDetail(id){
        this.$router.push({
        	name:'pdetail',
        	query: {
        		id
        	}
        });
        // 刷新页面
        this.$router.go(0);
      }

		}
	}
</script>

<style scoped lang="less">
  .solid-bottom{
    cursor: pointer;
  }

	.policy{
		width: 1210px;
		margin: 0 auto;
	}
	.detail{
		width: 793px;
		.detail-title{
			font-size: 32px;
		}
	}
	.title{
		position: relative;
		font-size: 22px;
		&:before{
			position: absolute;
			left: 0;
			top: 50%;
			transform: translateY(-50%);
			width: 6px;
			height: 26px;
			background: #09827B;
			content: '';

		}
	}
	.hotlist{
		p:last-child{
			border-bottom: 0;
		}
	}
	.news{
		width: 387px;
	}

</style>



// WEBPACK FOOTER //
// src/view/index/policy-detail.vue